// torre-controladoria · DRE Live + Margem + Pareto + Leak Detector + Anomalias + Forecast
import {
  initAuth, getAuthContext, signInWithGoogle, signInWithMagicLink,
  applyTheme, createOrbitBackground,
  fetchJson, fmtBR, fmtBRL, fmtPct, fmtDate, fmtDateTime, escapeHtml, downloadCsv
} from '@zzyonbr/torre-shared';

const $ = sel => document.querySelector(sel);
const $$ = sel => Array.from(document.querySelectorAll(sel));
const num = v => Number(v || 0);

// Helper URL-encode para colunas com $
const encReceita = 'receita_r%24';

async function bootstrap() {
  await initAuth();
  const ctx = await getAuthContext();
  applyTheme(ctx.tenant?.branding || {});
  if (!ctx.user) { renderLogin(); return; }
  renderShell(ctx);
  setActiveTab(location.hash.slice(1) || 'dre');
  window.addEventListener('hashchange', () => setActiveTab(location.hash.slice(1) || 'dre'));
}

function renderLogin() {
  $('#app').innerHTML = `
    <div class="zzy-fade-up" style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;position:relative;overflow:hidden">
      <div id="orbit-host" style="position:absolute;inset:0;pointer-events:none"></div>
      <div class="zzy-card" style="max-width:440px;width:100%;text-align:center;padding:48px 36px">
        <div style="display:flex;justify-content:center;margin-bottom:28px"><zzy-logo size="56" sub="true"></zzy-logo></div>
        <div style="font:400 13px/1.4 var(--zzy-font);color:var(--zzy-text-mute);font-style:italic;margin-bottom:32px">Inteligência em órbita</div>
        <div style="height:1px;background:var(--zzy-border);margin:0 -36px 28px -36px"></div>
        <div class="zzy-eyebrow" style="margin-bottom:8px">Torre de Controle</div>
        <div class="zzy-h3" style="margin-bottom:28px">Controladoria</div>
        <button id="login-google" class="zzy-btn" style="width:100%;background:#FFFFFF;color:#1F1F1F;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:12px">
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Entrar com Google
        </button>
        <div style="display:flex;align-items:center;gap:10px;margin:14px 0;color:var(--zzy-text-mute);font:400 11px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.1em"><span style="flex:1;height:1px;background:var(--zzy-border)"></span>ou<span style="flex:1;height:1px;background:var(--zzy-border)"></span></div>
        <input id="email" type="email" placeholder="seu.email@empresa.com" class="zzy-input" style="margin-bottom:12px" />
        <button id="login-btn" class="zzy-btn zzy-btn--ghost" style="width:100%">Receber Magic Link por email</button>
        <div id="login-msg" style="margin-top:14px;font:400 12px/1.4 var(--zzy-font);color:var(--zzy-text-mute);min-height:18px"></div>
      </div>
    </div>
  `;
  $('#orbit-host')?.appendChild(createOrbitBackground());
  $('#login-google').addEventListener('click', () => signInWithGoogle(location.origin).catch(e => $('#login-msg').textContent = 'Erro: ' + e.message));
  $('#login-btn').addEventListener('click', async () => {
    const email = $('#email').value.trim();
    if (!email) { $('#login-msg').textContent = 'Informe um email'; return; }
    try {
      await signInWithMagicLink(email, location.origin);
      $('#login-msg').textContent = 'Link enviado!';
      $('#login-msg').style.color = 'var(--zzy-success)';
    } catch (err) {
      $('#login-msg').textContent = 'Erro: ' + err.message;
      $('#login-msg').style.color = 'var(--zzy-danger)';
    }
  });
}

function renderShell(ctx) {
  $('#app').innerHTML = `
    <zzy-toast></zzy-toast>
    <zzy-header module="Controladoria"></zzy-header>
    <main style="max-width:1500px;margin:0 auto;padding:24px">
      <nav id="tabs" style="display:flex;gap:8px;margin-bottom:20px;border-bottom:1px solid var(--zzy-border);padding-bottom:0;overflow-x:auto">
        <button data-tab="dre"        class="ct-tab ct-tab--active">DRE Live</button>
        <button data-tab="margem"     class="ct-tab">Margem por Frete</button>
        <button data-tab="pareto"     class="ct-tab">Concentração (Pareto)</button>
        <button data-tab="leak"       class="ct-tab">⚠️ Leak Detector</button>
        <button data-tab="rotas"      class="ct-tab">Margem por Rota</button>
        <button data-tab="anomalias"  class="ct-tab">Anomalias (Auditor)</button>
        <button data-tab="forecast"   class="ct-tab">Forecast 7d</button>
      </nav>
      <section id="content"></section>
    </main>
    <style>
      .ct-tab { background:transparent;border:0;color:var(--zzy-text-mute);padding:10px 18px;font:500 13px/1 var(--zzy-font);cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-1px;transition:color .15s,border-color .15s;white-space:nowrap; }
      .ct-tab:hover { color:var(--zzy-mist); }
      .ct-tab--active { color:var(--zzy-sky);border-bottom-color:var(--zzy-sky); }
      .ct-table { width:100%;border-collapse:collapse;font-size:12.5px; }
      .ct-table th { text-align:left;color:var(--zzy-text-mute);font:600 10px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.08em;padding:10px 12px;border-bottom:1px solid var(--zzy-border);position:sticky;top:0;background:var(--zzy-surface-solid); }
      .ct-table td { padding:10px 12px;border-bottom:1px solid var(--zzy-border);vertical-align:top; }
      .ct-table tr:hover td { background:rgba(255,255,255,.02); }
      .ct-badge { display:inline-block;padding:2px 8px;border-radius:4px;font:600 10px/1.4 var(--zzy-font);text-transform:uppercase;letter-spacing:.04em; }
      .ct-badge--ok    { background:rgba(34,197,94,.15);color:var(--zzy-success); }
      .ct-badge--warn  { background:rgba(245,158,11,.15);color:var(--zzy-warning); }
      .ct-badge--late  { background:rgba(239,68,68,.15);color:var(--zzy-danger); }
      .ct-stat { display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:14px;margin-bottom:24px; }
    </style>
  `;
  $$('.ct-tab').forEach(b => b.addEventListener('click', () => {
    location.hash = b.dataset.tab;
    setActiveTab(b.dataset.tab);
  }));
}

function setActiveTab(name) {
  $$('.ct-tab').forEach(b => b.classList.toggle('ct-tab--active', b.dataset.tab === name));
  if (name === 'dre')        loadDRE();
  if (name === 'margem')     loadMargem();
  if (name === 'pareto')     loadPareto();
  if (name === 'leak')       loadLeak();
  if (name === 'rotas')      loadRotas();
  if (name === 'anomalias')  loadAnomalias();
  if (name === 'forecast')   loadForecast();
}

async function loadDRE() {
  $('#content').innerHTML = `<zzy-spinner>Carregando DRE Live (sync 4×/dia ESL)…</zzy-spinner>`;
  try {
    const since = new Date(Date.now() - 30*86400000).toISOString().slice(0,10);
    const [filial, consol] = await Promise.all([
      fetchJson(`/vw_dre_diario_filial?dia=gte.${since}&order=dia.desc,${encReceita}.desc&limit=200`),
      fetchJson(`/vw_dre_diario_consolidado?dia=gte.${since}&order=dia.desc&limit=30`),
    ]);
    renderDRE({ filial, consol });
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

function renderDRE({ filial, consol }) {
  const totReceita = consol.reduce((s,r) => s + num(r.receita_r$), 0);
  const totCusto   = consol.reduce((s,r) => s + num(r.custo_total_r$), 0);
  const totMargem  = consol.reduce((s,r) => s + num(r.margem_r$), 0);
  const totFretes  = consol.reduce((s,r) => s + num(r.volume_fretes), 0);
  const totPrejuizo= consol.reduce((s,r) => s + num(r.fretes_prejuizo), 0);
  const margemPct  = totReceita > 0 ? (totMargem / totReceita * 100) : 0;
  const pctPrejuizo= totFretes > 0 ? (totPrejuizo / totFretes * 100) : 0;
  const hojeRow = consol[0] || {};

  $('#content').innerHTML = `
    <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ DRE Live · ESL → ZZYON cron 4×/dia</div>
    <div class="zzy-h3" style="margin-bottom:20px">Receita · Custo · Margem · últimos 30 dias</div>

    <div class="ct-stat">
      <div class="zzy-card" style="padding:18px">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Receita 30d</div>
        <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-mist)">${fmtBRL(totReceita)}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${totFretes} fretes</div>
      </div>
      <div class="zzy-card" style="padding:18px">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Custo 30d</div>
        <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-warning)">${fmtBRL(totCusto)}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${(totCusto/totReceita*100||0).toFixed(1)}% da receita</div>
      </div>
      <div class="zzy-card" style="padding:18px;border:1px solid ${margemPct >= 25 ? 'var(--zzy-success)' : 'var(--zzy-warning)'}">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Margem 30d</div>
        <div style="font:700 22px/1 var(--zzy-font);color:${margemPct >= 25 ? 'var(--zzy-success)' : 'var(--zzy-warning)'}">${fmtBRL(totMargem)}</div>
        <div style="font:600 13px/1 var(--zzy-font);color:${margemPct >= 25 ? 'var(--zzy-success)' : 'var(--zzy-warning)'};margin-top:6px">${margemPct.toFixed(2)}% · ${margemPct >= 25 ? 'OK' : 'ABAIXO ALVO 25%'}</div>
      </div>
      <div class="zzy-card" style="padding:18px;border:1px solid ${pctPrejuizo > 5 ? 'var(--zzy-danger)' : 'var(--zzy-border)'}">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Fretes em prejuízo</div>
        <div style="font:700 22px/1 var(--zzy-font);color:${pctPrejuizo > 5 ? 'var(--zzy-danger)' : 'var(--zzy-mist)'}">${totPrejuizo}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${pctPrejuizo.toFixed(1)}% dos fretes</div>
      </div>
      <div class="zzy-card" style="padding:18px">
        <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Hoje (${hojeRow.dia || '—'})</div>
        <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-sky)">${fmtBRL(num(hojeRow.receita_r$))}</div>
        <div style="font:400 11px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:6px">${num(hojeRow.volume_fretes)} fretes · margem ${fmtBRL(num(hojeRow.margem_r$))}</div>
      </div>
    </div>

    <div class="zzy-card" style="padding:24px">
      <div class="zzy-h4" style="margin-bottom:14px">DRE Diário por Filial</div>
      <table class="ct-table">
        <thead><tr>
          <th>Dia</th><th>Filial</th><th style="text-align:right">Vol.</th>
          <th style="text-align:right">Receita</th><th style="text-align:right">Custo</th>
          <th style="text-align:right">Margem R$</th><th style="text-align:right">Margem %</th>
          <th style="text-align:right">Prejuízo</th>
        </tr></thead>
        <tbody>
          ${filial.slice(0, 80).map(r => {
            const m = num(r.margem_pct);
            return `
            <tr>
              <td>${r.dia}</td>
              <td>${escapeHtml(r.filial || '?')}</td>
              <td style="text-align:right">${r.volume_fretes}</td>
              <td style="text-align:right;font-weight:600">${fmtBRL(num(r.receita_r$))}</td>
              <td style="text-align:right;color:var(--zzy-warning)">${fmtBRL(num(r.custo_total_r$))}</td>
              <td style="text-align:right">${fmtBRL(num(r.margem_r$))}</td>
              <td style="text-align:right;color:${m >= 25 ? 'var(--zzy-success)' : m > 0 ? 'var(--zzy-warning)' : 'var(--zzy-danger)'};font-weight:600">${m ? m.toFixed(2) + '%' : '—'}</td>
              <td style="text-align:right;color:${(r.fretes_prejuizo || 0) > 0 ? 'var(--zzy-danger)' : 'var(--zzy-text-mute)'}">${r.fretes_prejuizo || 0}</td>
            </tr>`;
          }).join('')}
        </tbody>
      </table>
    </div>
  `;
}

async function loadMargem() {
  $('#content').innerHTML = `<zzy-spinner>Carregando últimos 200 fretes com margem…</zzy-spinner>`;
  try {
    const data = await fetchJson('/cs_fretes_margens?order=service_at.desc&limit=200');
    $('#content').innerHTML = `
      <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ Margem por Frete · /api/report/freight/margins (live)</div>
      <div class="zzy-h3" style="margin-bottom:20px">Últimos 200 fretes com margem calculada</div>
      <div class="zzy-card" style="padding:24px">
        <table class="ct-table">
          <thead><tr>
            <th>Data</th><th>Filial</th><th>CT-e</th><th>Origem→Destino</th>
            <th style="text-align:right">Peso</th>
            <th style="text-align:right">Receita</th><th style="text-align:right">Custo</th>
            <th style="text-align:right">Margem R$</th><th style="text-align:right">Margem %</th>
          </tr></thead>
          <tbody>
            ${data.map(r => {
              const m = num(r.margin_percentual);
              return `
              <tr>
                <td>${fmtDate(r.service_at)}</td>
                <td style="font-size:11px">${escapeHtml(r.corporation_nickname || '?')}</td>
                <td style="font-family:monospace;font-size:11px">${escapeHtml(r.cte_number || '—')}</td>
                <td style="font-size:11px">${escapeHtml(r.origin_city_name || '?')}/${r.origin_state_code || '?'} → ${escapeHtml(r.destination_city_name || '?')}/${r.destination_state_code || '?'}</td>
                <td style="text-align:right">${num(r.real_weight).toFixed(1)} kg</td>
                <td style="text-align:right;font-weight:600">${fmtBRL(num(r.freight_total))}</td>
                <td style="text-align:right;color:var(--zzy-warning)">${fmtBRL(num(r.total_expenses))}</td>
                <td style="text-align:right;color:${num(r.margin_total) < 0 ? 'var(--zzy-danger)' : 'inherit'};font-weight:600">${fmtBRL(num(r.margin_total))}</td>
                <td style="text-align:right;color:${m >= 25 ? 'var(--zzy-success)' : m > 0 ? 'var(--zzy-warning)' : 'var(--zzy-danger)'};font-weight:600">${m.toFixed(2)}%</td>
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

async function loadPareto() {
  $('#content').innerHTML = `<zzy-spinner>Carregando concentração Pareto…</zzy-spinner>`;
  try {
    const data = await fetchJson('/vw_concentracao_pareto?limit=30');
    $('#content').innerHTML = `
      <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ Pareto · concentração de receita por cliente (30d)</div>
      <div class="zzy-h3" style="margin-bottom:20px">Top 30 clientes — quem gera 80% da receita?</div>
      <div class="zzy-card" style="padding:24px">
        <button id="ct-export-pareto" class="zzy-btn zzy-btn--ghost" style="font-size:11px;padding:6px 12px;margin-bottom:14px">Exportar CSV</button>
        <table class="ct-table">
          <thead><tr>
            <th>#</th><th>Cliente</th><th style="text-align:right">Volume</th>
            <th style="text-align:right">Receita</th><th style="text-align:right">Margem R$</th>
            <th style="text-align:right">Margem %</th><th style="text-align:right">% Receita</th>
            <th style="text-align:right">% Acum.</th>
          </tr></thead>
          <tbody>
            ${data.map(p => {
              const m = num(p.receita_r$) > 0 ? (num(p.margem_r$) / num(p.receita_r$) * 100) : 0;
              const isWarn = m < 25 && m >= 0;
              const isCrit = m < 0;
              return `
              <tr>
                <td>${p.rank}</td>
                <td><strong>${escapeHtml(p.cliente || '?')}</strong></td>
                <td style="text-align:right">${p.volume}</td>
                <td style="text-align:right;font-weight:600">${fmtBRL(num(p.receita_r$))}</td>
                <td style="text-align:right;color:${isCrit ? 'var(--zzy-danger)' : 'inherit'}">${fmtBRL(num(p.margem_r$))}</td>
                <td style="text-align:right;color:${isCrit ? 'var(--zzy-danger)' : isWarn ? 'var(--zzy-warning)' : 'var(--zzy-success)'};font-weight:600">${m.toFixed(2)}%</td>
                <td style="text-align:right">${p.pct_receita}%</td>
                <td style="text-align:right;color:var(--zzy-text-mute)">${p.pct_acumulado}%</td>
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>
    `;
    $('#ct-export-pareto')?.addEventListener('click', () => downloadCsv('pareto_clientes.csv', data));
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

async function loadLeak() {
  $('#content').innerHTML = `<zzy-spinner>Detectando leaks (margem &lt; P25)…</zzy-spinner>`;
  try {
    const data = await fetchJson('/vw_leak_detector?order=margem_pct.asc&limit=100');
    const totalLeak = data.reduce((s,r) => s + num(r.margem_r$), 0);
    $('#content').innerHTML = `
      <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ Leak Detector · z-score em tempo real</div>
      <div class="zzy-h3" style="margin-bottom:20px">⚠️ Fretes em prejuízo ou margem &lt; P25</div>
      <div class="ct-stat">
        <div class="zzy-card" style="padding:18px;border:1px solid var(--zzy-danger)">
          <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Alertas detectados</div>
          <div style="font:700 22px/1 var(--zzy-font);color:var(--zzy-danger)">${data.length}</div>
        </div>
        <div class="zzy-card" style="padding:18px">
          <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">Impacto na margem</div>
          <div style="font:700 22px/1 var(--zzy-font);color:${totalLeak < 0 ? 'var(--zzy-danger)' : 'var(--zzy-warning)'}">${fmtBRL(totalLeak)}</div>
        </div>
      </div>
      <div class="zzy-card" style="padding:24px">
        <table class="ct-table">
          <thead><tr>
            <th>Dia</th><th>Filial</th><th>CT-e</th><th>Cliente</th>
            <th>Origem→Destino</th><th style="text-align:right">Receita</th>
            <th style="text-align:right">Custo</th><th style="text-align:right">Margem R$</th>
            <th style="text-align:right">Margem %</th><th>Classif.</th><th style="text-align:right">Z-score</th>
          </tr></thead>
          <tbody>
            ${data.map(l => {
              const cls = l.classificacao;
              const cor = cls === 'PREJUIZO' ? 'var(--zzy-danger)' : cls === 'OUTLIER_P10' ? 'var(--zzy-warning)' : 'var(--zzy-text-mute)';
              return `
              <tr>
                <td>${l.dia}</td>
                <td style="font-size:11px">${escapeHtml(l.filial || '?')}</td>
                <td style="font-family:monospace;font-size:11px">${escapeHtml(l.cte_number || '—')}</td>
                <td>${escapeHtml((l.cliente || '?').slice(0, 25))}</td>
                <td style="font-size:11px">${escapeHtml(l.origem || '?')} → ${escapeHtml(l.destino || '?')}</td>
                <td style="text-align:right">${fmtBRL(num(l.receita_r$))}</td>
                <td style="text-align:right;color:var(--zzy-warning)">${fmtBRL(num(l.custo_r$))}</td>
                <td style="text-align:right;color:${num(l.margem_r$) < 0 ? 'var(--zzy-danger)' : 'inherit'};font-weight:600">${fmtBRL(num(l.margem_r$))}</td>
                <td style="text-align:right;color:${num(l.margem_pct) < 0 ? 'var(--zzy-danger)' : 'var(--zzy-warning)'};font-weight:600">${num(l.margem_pct).toFixed(2)}%</td>
                <td><span class="ct-badge" style="background:${cor};color:white">${cls}</span></td>
                <td style="text-align:right;font-family:monospace;color:${Math.abs(num(l.z_score)) > 2 ? 'var(--zzy-danger)' : 'var(--zzy-text-mute)'}">${l.z_score || '—'}</td>
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

async function loadRotas() {
  $('#content').innerHTML = `<zzy-spinner>Carregando margem por rota…</zzy-spinner>`;
  try {
    const data = await fetchJson('/vw_margem_por_rota?order=volume_fretes.desc&limit=50');
    $('#content').innerHTML = `
      <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ Margem por Rota</div>
      <div class="zzy-h3" style="margin-bottom:20px">Top 50 rotas mais movimentadas (30d)</div>
      <div class="zzy-card" style="padding:24px">
        <table class="ct-table">
          <thead><tr>
            <th>Origem</th><th>Destino</th><th style="text-align:right">Volume</th>
            <th style="text-align:right">Receita</th><th style="text-align:right">Margem R$</th>
            <th style="text-align:right">Margem %</th><th style="text-align:right">Peso médio</th>
            <th style="text-align:right">Prejuízo</th>
          </tr></thead>
          <tbody>
            ${data.map(r => {
              const m = num(r.margem_pct_media);
              return `
              <tr>
                <td>${escapeHtml(r.origem || '?')}</td>
                <td>${escapeHtml(r.destino || '?')}</td>
                <td style="text-align:right">${r.volume_fretes}</td>
                <td style="text-align:right;font-weight:600">${fmtBRL(num(r.receita_r$))}</td>
                <td style="text-align:right">${fmtBRL(num(r.margem_r$_total))}</td>
                <td style="text-align:right;color:${m >= 25 ? 'var(--zzy-success)' : m > 0 ? 'var(--zzy-warning)' : 'var(--zzy-danger)'};font-weight:600">${m.toFixed(2)}%</td>
                <td style="text-align:right">${num(r.peso_medio_kg).toFixed(1)} kg</td>
                <td style="text-align:right;color:${(r.fretes_prejuizo||0)>0?'var(--zzy-danger)':'var(--zzy-text-mute)'}">${r.fretes_prejuizo || 0}</td>
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

async function loadAnomalias() {
  $('#content').innerHTML = `<zzy-spinner>Carregando anomalias do Auditor Virtual…</zzy-spinner>`;
  try {
    const data = await fetchJson('/cs_anomalias_detectadas?order=detected_at.desc&limit=100');
    const stats = data.reduce((acc, a) => { acc[a.severity] = (acc[a.severity] || 0) + 1; return acc; }, {});
    $('#content').innerHTML = `
      <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ Auditor Virtual · 6 detectores rodando 04h diário</div>
      <div class="zzy-h3" style="margin-bottom:20px">Anomalias: prejuízo, margem cliente, receita zero, cancelamento, inadimplência</div>
      <div class="ct-stat">
        ${['critical','high','medium','low'].map(s => `
          <div class="zzy-card" style="padding:18px;border:1px solid ${s==='critical'?'var(--zzy-danger)':s==='high'?'var(--zzy-warning)':'var(--zzy-border)'}">
            <div style="font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px">${s.toUpperCase()}</div>
            <div style="font:700 22px/1 var(--zzy-font);color:${s==='critical'?'var(--zzy-danger)':s==='high'?'var(--zzy-warning)':'var(--zzy-mist)'}">${stats[s] || 0}</div>
          </div>
        `).join('')}
      </div>
      <div class="zzy-card" style="padding:24px">
        <table class="ct-table">
          <thead><tr>
            <th>Detector</th><th>Severidade</th><th>Tipo</th><th>Entidade</th>
            <th style="text-align:right">Métrica</th><th>Detectado em</th><th>Status</th>
          </tr></thead>
          <tbody>
            ${data.map(a => `
              <tr>
                <td><strong>${escapeHtml(a.detector || '?')}</strong></td>
                <td><span class="ct-badge ${a.severity==='critical'?'ct-badge--late':a.severity==='high'?'ct-badge--warn':'ct-badge--ok'}">${a.severity}</span></td>
                <td>${escapeHtml(a.entity_type || '?')}</td>
                <td>${escapeHtml((a.entity_id || '?').slice(0, 40))}</td>
                <td style="text-align:right;font-family:monospace">${num(a.metric_value).toFixed(2)}</td>
                <td>${fmtDateTime(a.detected_at)}</td>
                <td><span class="ct-badge ${a.resolved?'ct-badge--ok':'ct-badge--warn'}">${a.resolved?'resolvido':'aberto'}</span></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

async function loadForecast() {
  $('#content').innerHTML = `<zzy-spinner>Carregando previsões 7d (Preditor Virtual)…</zzy-spinner>`;
  try {
    const data = await fetchJson('/cs_previsoes?metric=eq.margem_pct_filial&order=scope_id.asc,forecast_date.asc&limit=200');
    $('#content').innerHTML = `
      <div class="zzy-eyebrow" style="margin-bottom:8px;color:var(--zzy-gold,#B9892D)">★ Preditor Virtual · forecast diário 04h30</div>
      <div class="zzy-h3" style="margin-bottom:20px">Previsão de margem 7 dias por filial (modelo avg_14d_linear v1)</div>
      <div class="zzy-card" style="padding:24px">
        <table class="ct-table">
          <thead><tr>
            <th>Filial</th><th>Data prevista</th>
            <th style="text-align:right">Margem prevista</th>
            <th style="text-align:right">Conf. baixa</th><th style="text-align:right">Conf. alta</th>
            <th style="text-align:right">Volume previsto</th><th>Confiança</th>
          </tr></thead>
          <tbody>
            ${data.map(p => `
              <tr>
                <td><strong>${escapeHtml(p.scope_id || '?')}</strong></td>
                <td>${fmtDate(p.forecast_date)}</td>
                <td style="text-align:right;font-weight:600">${num(p.predicted_value).toFixed(2)}%</td>
                <td style="text-align:right;color:var(--zzy-text-mute)">${num(p.confidence_low).toFixed(2)}%</td>
                <td style="text-align:right;color:var(--zzy-text-mute)">${num(p.confidence_high).toFixed(2)}%</td>
                <td style="text-align:right">${p.features_used?.volume_predito || '—'}</td>
                <td><span class="ct-badge ${p.features_used?.confianca==='alta'?'ct-badge--ok':'ct-badge--warn'}">${p.features_used?.confianca || '—'}</span></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger);padding:24px">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

bootstrap();
